module.exports = __webpack_public_path__ + "static/media/analysi.a5e37573.png";